(() => {
  const roots = document.querySelectorAll('[data-st-library]');
  if (!roots.length) return;

  const categoryCards = [
    { id: 'full-body', title: 'Full body', sub: 'Move your whole body', imageId: 'xe_7GhJVW-U' },
    { id: 'quick', title: 'Short on time', sub: 'Sessions under 20 minutes', imageId: 'pETl55R9Fao' },
    { id: 'stretch', title: 'Stretch & mobility', sub: 'A lower-demand way to move', imageId: '8bPu0ypBXK4' },
    { id: 'pilates', title: 'Pilates', sub: 'Control, strength, and flow', imageId: 'kr9wIU1MsL0' },
    { id: 'mindful', title: 'Guided movement', sub: 'Move with a voice to follow', imageId: '7XnrTbAUBdg' },
    { id: 'no-equipment', title: 'No equipment', sub: 'Use what you already have', imageId: 'gOG3_1BUkFI' }
  ];
  const needShortcuts = [
    { label: 'Overthinking', key: 'overthinking', values: ['Overthinking / racing thoughts'] },
    { label: 'Overstimulation', key: 'overstim', values: ['Overstimulation / overwhelm'] },
    { label: 'Burnout or low energy', key: 'burnout', values: ['Burnout / depletion', 'Low energy / reset'] },
    { label: 'Brain fog', key: 'brain fog', values: ['Brain fog / focus'] },
    { label: 'Anxiety or stress', key: 'anxiety', values: ['Anxiety / stress'] },
    { label: 'Getting started', key: 'routine', values: ['Routine / getting started'] },
    { label: 'Short on time', key: 'short on time', values: ['Short on time / busy day'] }
  ];
  const categoryFilters = {
    'full-body': { key: 'focus', values: ['Full body'] },
    quick: { key: 'duration', values: ['Under 10 min', '10–19 min'] },
    stretch: { key: 'format', values: ['Stretch / mobility'] },
    pilates: { key: 'format', values: ['Pilates'] },
    mindful: null,
    'no-equipment': { key: 'equipment', values: ['No equipment required (bodyweight)'] }
  };
  const guidedMovementPlaylists = new Set([
    'Active Guided Meditation',
    'Sweat Therapy - guided movement with a voice that meets you where you are'
  ].map(name => name.toLowerCase()));
  const belongsToGuidedPlaylist = session => (session.playlists || []).some(name => guidedMovementPlaylists.has(String(name).trim().toLowerCase()));
  const facets = [
    { key: 'moments', title: 'What do you need help with today?', candidates: [
      'Overthinking / racing thoughts','Overstimulation / overwhelm','Overstimulation / too much','Burnout / depletion','Brain fog / focus','Anxiety / stress','Low energy / exhaustion','Low energy / reset','Routine / getting started','Short on time / busy day','Short on time / quick start','Self-care / pause','Self-care / pause for yourself','Desk break / sitting','Stiffness / tightness','Rest / recovery','Focus / grounding','Longer sessions / build strength','Morning start','Night / sleep','PMS / menstrual discomfort','Post-workout recovery','Transition / end of day','Active guided meditation'
    ] },
    { key: 'format', title: 'Movement type', candidates: ['Pilates','Guided meditation','Stretch / mobility','Cardio / conditioning','Strength / sculpt','Workout / movement'] },
    { key: 'duration', title: 'Time', candidates: ['Under 10 min','10–19 min','20–29 min','30–44 min','45+ min'] },
    { key: 'focus', title: 'Body focus', candidates: ['Full body','Upper body / arms','Core / abs','Glutes / booty','Lower body / legs / hips','Back / chest / posture'] },
    { key: 'equipment', title: 'Equipment', candidates: ['No equipment required (bodyweight)','Dumbbells / hand weights','Dumbbells / hand weights (optional)','Resistance band','Resistance band (optional)'] },
    { key: 'access', title: 'Access', candidates: ['Public','Members-only'] }
  ];
  const durationMatches = (session, bucket) => {
    const n = Number(session.durationSeconds || 0);
    if (bucket === 'Under 10 min') return n > 0 && n < 600;
    if (bucket === '10–19 min') return n >= 600 && n < 1200;
    if (bucket === '20–29 min') return n >= 1200 && n < 1800;
    if (bucket === '30–44 min') return n >= 1800 && n < 2700;
    if (bucket === '45+ min') return n >= 2700;
    return false;
  };
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[char]));
  const formatDuration = value => {
    const seconds = Number(value || 0);
    if (!seconds) return '';
    const minutes = Math.floor(seconds / 60);
    return `${minutes} min`;
  };

  roots.forEach(root => {
    const dataUrl = root.dataset.catalogUrl;
    const searchInput = root.querySelector('[data-search-input]');
    const clearSearch = root.querySelector('[data-clear-search]');
    const needsList = root.querySelector('[data-need-list]');
    const categoryGrid = root.querySelector('[data-category-grid]');
    const resultGrid = root.querySelector('[data-results]');
    const resultCount = root.querySelector('[data-result-count]');
    const searchFeedback = root.querySelector('[data-search-feedback]');
    const needFeedback = root.querySelector('[data-need-feedback]');
    const categoryFeedback = root.querySelector('[data-category-feedback]');
    const activeList = root.querySelector('[data-active-filters]');
    const emptyState = root.querySelector('[data-empty-state]');
    const loadMore = root.querySelector('[data-load-more]');
    const filterButton = root.querySelector('[data-open-filters]');
    const filterCount = root.querySelector('[data-filter-count]');
    const dialog = root.querySelector('[data-filter-dialog]');
    const filterGroups = root.querySelector('[data-filter-groups]');
    const sortControl = root.querySelector('[data-sort]');
    const sessionsSection = root.querySelector('[data-results-section]');
    const recentWorkoutRow = root.querySelector('[data-fresh-workouts]');
    const recentStretchRow = root.querySelector('[data-fresh-stretches]');
    const embeddedCatalog = root.querySelector('[data-library-catalog]');
    let allSessions = [];
    let guidedMovementSessions = [];
    let visibleSessions = [];
    let applied = {};
    let selectedCategory = '';
    let selectedNeed = '';
    let usedSearchFallback = false;
    let shown = 12;
    const perPage = 12;
    const scrollToResults = () => sessionsSection?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });

    // Search natural descriptions as well as the session's finder moments. A visitor's
    // wording is translated into broad needs; several needs are treated as OR matches,
    // then ranked by how many of those needs a session covers.
    const normalizeSearchText = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’‘']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const searchAliases = [
      { query: /\b(overthinking|overthink|ruminating|ruminate|replaying|racing thoughts|racing mind|racing|spiraling|spiral|cant switch off|cannot switch off|cant shut off|cannot shut off|wont switch off|wont stop thinking|brain wont shut up|mind wont shut up|brain wont stop|mind wont stop|stuck in my head)\b/, content: /overthink|ruminat|replay|racing thought|racing mind|brain racing|thoughts racing|loop|spiral|brain wont|mind wont|switch off|shut off|wont stop thinking/ },
      { query: /\b(stress|stressed|stressful|anxiety|anxious|overwhelm|overwhelmed|overloaded|tense|tension|pressure|under pressure|on edge|wired|panic|panicky|frazzled)\b/, content: /stress|anx|overwhelm|overload|tense|tension|pressure|panic|nervous system|overstimul|sensory/ },
      { query: /\b(burnout|burned out|burnt out|burn out|exhausted|exhaustion|depleted|drained|worn out|worn down|overworked|running on empty|running on fumes|cant keep going|cant keep up)\b/, content: /burnout|burned out|burnt out|exhaust|deplet|drain|worn out|running on empty|running on fumes|fatigue|low energy|cant keep up|overwork/ },
      { query: /\b(low energy|no energy|tired|fatigued|sluggish|cant get going|wiped out|run down|out of steam)\b/, content: /low energy|no energy|tired|fatigue|sluggish|deplet|drain|exhaust|running on empty|worn down/ },
      { query: /\b(brain fog|foggy|scattered|cant focus|trouble focusing|cant concentrate|cant think straight|concentrat|distracted)\b/, content: /brain fog|concentrat|scattered|attention|cant focus|stay focused|think straight/ },
      { query: /\b(procrastinat|stuck|getting started|cant start|cant begin|cant get started|putting it off|avoiding starting|no motivation|unmotivated)\b/, content: /procrastinat|stuck|start|begin|routine|motivation|show up|small step|short session/ },
      { query: /\b(overstimulation|overstimulated|overstim|sensory|hypersensitive|too much|too many|noise|noisy|loud|crowded|chaotic)\b/, content: /overstimul|sensory|hypersensit|too much|overwhelm|input|noise|noisy|loud|crowd|chaos|calm|settle|release/ },
      { query: /\b(short on time|busy|quick|few minutes|little time)\b/, content: /short on time|busy|quick|10 min|15 min|20 min|short session/ },
      { query: /\b(stretch|stretching|mobility|tight|stiff)\b/, content: /stretch|mobility|flexibility|tight|stiff/ },
      { query: /\b(meditat|mindful|calm down|wind down|relax|settle)\b/, content: /meditat|guided practice|mindful|calm|settle|unwind|relax/ },
      { query: /\b(pilates)\b/, content: /pilates/ },
      { query: /\b(sleep|cant sleep|bedtime|night)\b/, content: /sleep|night|bedtime|unwind|rest/ }
    ];
    const sessionSearchText = session => normalizeSearchText([session.title || '', session.description || '', ...(session.moments || [])].join(' '));
    const queryConcepts = rawQuery => {
      const query = normalizeSearchText(rawQuery);
      return searchAliases.filter(alias => alias.query.test(query));
    };
    // Meaning-based search stays in the visitor's browser worker; queries are not sent to a search server.
    let semanticWorker = null;
    let semanticVectors = new Map();
    let semanticQueryVector = null;
    let semanticQueryText = '';
    let semanticIndexReady = false;
    let semanticIndexFailed = false;
    let semanticQueryRevision = 0;
    let pendingSemanticQuery = '';
    const vectorSimilarity = (left, right) => {
      if (!left || !right || left.length !== right.length) return 0;
      let score = 0;
      for (let i = 0; i < left.length; i++) score += left[i] * right[i];
      return score;
    };
    const startSemanticIndex = () => {
      if (semanticWorker || semanticIndexFailed || !allSessions.length) return;
      const workerUrl = root.dataset.searchWorkerUrl;
      if (!workerUrl || typeof Worker === 'undefined') { semanticIndexFailed = true; return; }
      try {
        semanticWorker = new Worker(workerUrl);
        semanticWorker.onmessage = event => {
          const message = event.data || {};
          if (message.type === 'index-ready') {
            const vectors = new Float32Array(message.vectors);
            const dimensions = Number(message.dimensions || 384);
            semanticVectors = new Map(message.ids.map((id, index) => [id, Array.from(vectors.subarray(index * dimensions, (index + 1) * dimensions))]));
            semanticIndexReady = true;
            if (pendingSemanticQuery || searchInput?.value.trim().length >= 3) requestSemanticQuery(pendingSemanticQuery || searchInput.value.trim());
          } else if (message.type === 'query-ready' && message.revision === semanticQueryRevision) {
            const query = pendingSemanticQuery;
            if (query && searchInput?.value.trim() === query) {
              semanticQueryVector = Array.from(message.vector);
              semanticQueryText = query;
              pendingSemanticQuery = '';
              render();
            }
          } else if (message.type === 'error') {
            semanticIndexFailed = true;
            console.warn('Local semantic search is unavailable; keyword search remains active.', message.message);
          }
        };
        semanticWorker.onerror = error => { semanticIndexFailed = true; console.warn('Local semantic search is unavailable; keyword search remains active.', error); };
        semanticWorker.postMessage({ type: 'index', ids: allSessions.map(session => session.id), texts: allSessions.map(session => [session.title || '', session.description || '', ...(session.moments || []), ...(session.format || []), ...(session.focus || []), ...(session.equipment || [])].join('. ').slice(0, 1800)) });
      } catch (error) {
        semanticIndexFailed = true;
        console.warn('Local semantic search is unavailable; keyword search remains active.', error);
      }
    };
    const requestSemanticQuery = query => {
      const value = String(query || '').trim();
      if (value.length < 3 || semanticIndexFailed) return;
      pendingSemanticQuery = value;
      startSemanticIndex();
      if (!semanticWorker || !semanticIndexReady) return;
      const revision = ++semanticQueryRevision;
      semanticWorker.postMessage({ type: 'query', revision, text: value });
    };
    const lexicalSearchScore = (session, rawQuery) => {
      const query = normalizeSearchText(rawQuery);
      if (!query) return 0;
      const text = sessionSearchText(session);
      const concepts = queryConcepts(query);
      if (concepts.length) return concepts.reduce((score, concept) => score + (concept.content.test(text) ? 1 : 0), 0);
      const stopWords = new Set(['a','an','and','are','as','about','again','all','am','an','are','at','be','been','being','because','brain','but','can','do','does','doing','for','from','get','got','have','having','help','how','i','im','in','is','it','just','like','me','mind','my','head','of','on','or','please','really','so','the','that','this','to','very','was','were','what','when','where','with','why','you','your','feel','feels','feeling','today','day','thing','things','something','anything','everything','much','still','well']);
      const words = [...new Set(query.split(' ').filter(word => word.length > 2 && !stopWords.has(word)))];
      return words.reduce((score, word) => score + (text.split(' ').includes(word) ? 1 : 0), 0);
    };
    const searchScore = (session, rawQuery) => {
      const query = String(rawQuery || '').trim();
      const lexical = lexicalSearchScore(session, query);
      if (semanticQueryText === query && semanticQueryVector) {
        const semantic = vectorSimilarity(semanticVectors.get(session.id), semanticQueryVector);
        return semantic + Math.min(lexical, 3) * 0.035;
      }
      return lexical;
    };
    const searchMatches = (session, rawQuery) => {
      if (!normalizeSearchText(rawQuery)) return true;
      if (semanticQueryText === String(rawQuery || '').trim() && semanticQueryVector) return searchScore(session, rawQuery) >= 0.32;
      return lexicalSearchScore(session, rawQuery) > 0;
    };
    const includesCategory = (session, category) => {
      if (!category) return true;
      const title = (session.title || '').toLowerCase();
      const focus = (session.focus || []).join(' ').toLowerCase();
      const equipment = (session.equipment || []).join(' ').toLowerCase();
      if (category === 'full-body') return /full body|full-body/.test(focus + ' ' + title);
      if (category === 'quick') return Number(session.durationSeconds || 0) > 0 && Number(session.durationSeconds || 0) < 1200;
      if (category === 'stretch') return /\b(stretch|stretching|mobility|flexibility)\b/.test(title);
      if (category === 'pilates') return /\bpilates\b/.test(title);
      if (category === 'mindful') return belongsToGuidedPlaylist(session);
      if (category === 'no-equipment') return /no equipment required|bodyweight/.test(equipment + ' ' + title);
      return true;
    };

    const groupValues = session => ({
      moments: [...new Set((session.moments || []).map(value => ({ 'Overstimulation / too much': 'Overstimulation / overwhelm', 'Low energy / exhaustion': 'Low energy / reset', 'Short on time / quick start': 'Short on time / busy day', 'Self-care / pause for yourself': 'Self-care / pause' }[value] || value)))],
      format: session.format || [],
      duration: facets.find(f => f.key === 'duration').candidates.filter(value => durationMatches(session, value)),
      focus: session.focus || [],
      equipment: session.equipment || [],
      access: [session.access || 'Needs review']
    });
    const getFiltered = () => {
      const query = (searchInput?.value || '').trim();
      const matchesChosenFilters = session => {
        if (!includesCategory(session, selectedCategory)) return false;
        for (const [key, selected] of Object.entries(applied)) {
          if (!selected.length) continue;
          const values = groupValues(session)[key] || [];
          if (key === 'duration') {
            if (!selected.some(value => durationMatches(session, value))) return false;
          } else if (key === 'access') {
            if (!selected.includes(session.access)) return false;
          } else if (!selected.some(value => values.includes(value))) return false;
        }
        return true;
      };
      const sourceSessions = selectedCategory === 'mindful' ? guidedMovementSessions : allSessions;
      const candidates = sourceSessions.filter(matchesChosenFilters);
      if (!query) { usedSearchFallback = false; return candidates; }
      if (semanticQueryText === query && semanticQueryVector) {
        const ranked = candidates.map(session => ({ session, score: searchScore(session, query) }))
          .sort((a,b) => b.score - a.score || Date.parse(b.session.publishedAt || '') - Date.parse(a.session.publishedAt || ''));
        const relevant = ranked.filter(item => item.score >= 0.32);
        if (relevant.length) { usedSearchFallback = false; return relevant.slice(0, 24).map(item => item.session); }
        usedSearchFallback = true;
        return ranked.slice(0, Math.min(8, ranked.length)).map(item => item.session);
      }
      const concepts = queryConcepts(query);
      const scored = candidates.map(session => ({ session, score: lexicalSearchScore(session, query) })).filter(item => item.score > 0);
      const complete = concepts.length > 1 ? scored.filter(item => item.score === concepts.length) : scored;
      if (complete.length) { usedSearchFallback = false; return complete.map(item => item.session); }
      if (scored.length) {
        usedSearchFallback = true;
        return scored.sort((a,b) => b.score - a.score || Date.parse(b.session.publishedAt || '') - Date.parse(a.session.publishedAt || '')).slice(0, 8).map(item => item.session);
      }
      // Unrecognized wording should never end in a dead end. Offer a small, curated
      // set of general support sessions, while retaining any selected filters.
      usedSearchFallback = true;
      const supportive = candidates.filter(session => /anxiety stress|low energy reset|overstimulation overwhelm|focus grounding|self care pause|routine getting started|overthinking racing thoughts/i.test(normalizeSearchText((session.moments || []).join(' '))));
      const fallback = supportive.length ? supportive : candidates;
      return fallback.sort((a,b) => Date.parse(b.publishedAt || '') - Date.parse(a.publishedAt || '')).slice(0, 6);
    };
    const cardMarkup = session => `<article class="st-library-page__card">
      <a class="st-library-page__card-media" href="${escapeHtml(session.url)}" target="_blank" rel="noopener" aria-label="Watch ${escapeHtml(session.title)} on YouTube">
        <img src="${escapeHtml(session.thumbnail)}" alt="${escapeHtml(session.title)}" loading="lazy" width="480" height="300">
        <span class="st-library-page__duration">${escapeHtml(formatDuration(session.durationSeconds))}</span>
        <span class="st-library-page__access ${session.access === 'Members-only' ? 'st-library-page__access--members' : 'st-library-page__access--public'}">${session.access === 'Members-only' ? 'Members-only on YouTube' : 'Public on YouTube'}</span>
      </a>
      <div class="st-library-page__card-info">
        <a class="st-library-page__card-title" href="${escapeHtml(session.url)}" target="_blank" rel="noopener">${escapeHtml(session.title)}</a>
        <p class="st-library-page__card-meta"><span>${escapeHtml((session.format || [])[0] || 'Movement')}</span>${(session.focus || []).slice(0,1).map(value => `<span>${escapeHtml(value)}</span>`).join('')}</p>
        <a class="st-library-page__card-cta" href="${escapeHtml(session.url)}" target="_blank" rel="noopener">Watch session <span aria-hidden="true">↗</span></a>
      </div>
    </article>`;
    const renderFeaturedRow = (container, playlistPattern) => {
      if (!container) return;
      const entries = allSessions.filter(session => (session.playlists || []).some(name => playlistPattern.test(name)))
        .sort((a,b) => Date.parse(b.publishedAt || '') - Date.parse(a.publishedAt || ''))
        .slice(0, 2);
      container.innerHTML = entries.map(cardMarkup).join('');
      const group = container.closest('[data-fresh-group]');
      if (group) group.hidden = entries.length === 0;
    };
    const renderNeedAndCategories = () => {
      if (needsList) needsList.innerHTML = needShortcuts.map(item => `<li><button class="st-library-page__need-chip" type="button" data-need-query="${escapeHtml(item.key)}" aria-pressed="false">${escapeHtml(item.label)}</button></li>`).join('');
      if (categoryGrid) categoryGrid.innerHTML = categoryCards.map(card => `<button type="button" class="st-library-page__category" data-category="${card.id}" aria-pressed="false">
        <img src="https://i.ytimg.com/vi/${card.imageId}/hqdefault.jpg" alt="" loading="lazy" width="480" height="360">
        <span class="st-library-page__category-copy"><strong>${escapeHtml(card.title)}</strong><small>${escapeHtml(card.sub)}</small></span>
      </button>`).join('');
    };
    const renderActiveFilters = () => {
      if (!activeList) return;
      const chips = [];
      if (selectedCategory) { const filter = categoryFilters[selectedCategory]; const represented = filter && filter.values.every(value => (applied[filter.key] || []).includes(value)); if (!represented) chips.push({ key: 'category', value: selectedCategory, label: categoryCards.find(item => item.id === selectedCategory)?.title || selectedCategory }); }
      for (const [key, values] of Object.entries(applied)) for (const value of values) chips.push({ key, value, label: value });
      activeList.innerHTML = chips.map((chip,index) => `<span class="st-library-page__active-filter">${escapeHtml(chip.label)}<button type="button" data-remove-filter="${index}" aria-label="Remove ${escapeHtml(chip.label)} filter">×</button></span>`).join('');
      activeList.querySelectorAll('[data-remove-filter]').forEach(button => button.addEventListener('click', () => {
        const chip = chips[Number(button.dataset.removeFilter)];
        if (chip.key === 'category') { selectedCategory = ''; root.querySelectorAll('[data-category]').forEach(item => item.setAttribute('aria-pressed','false')); }
        else { applied[chip.key] = (applied[chip.key] || []).filter(item => item !== chip.value); }
        syncDialog(); render();
      }));
    };
    const renderResults = () => {
      visibleSessions = getFiltered();
      const sorted = [...visibleSessions];
      const sort = sortControl?.value || 'newest';
      if (sort === 'shortest') sorted.sort((a,b) => a.durationSeconds - b.durationSeconds);
      else if (sort === 'longest') sorted.sort((a,b) => b.durationSeconds - a.durationSeconds);
      else if (sort === 'title') sorted.sort((a,b) => a.title.localeCompare(b.title));
      else if ((searchInput?.value || '').trim()) sorted.sort((a,b) => searchScore(b, searchInput.value) - searchScore(a, searchInput.value) || Date.parse(b.publishedAt || '') - Date.parse(a.publishedAt || ''));
      else sorted.sort((a,b) => Date.parse(b.publishedAt || '') - Date.parse(a.publishedAt || ''));
      const current = sorted.slice(0, shown);
      if (resultGrid) resultGrid.innerHTML = current.map(cardMarkup).join('');
            if (resultCount) resultCount.textContent = `${visibleSessions.length} ${visibleSessions.length === 1 ? 'session' : 'sessions'}`;
      const resultsHeading = root.querySelector('.st-library-page__results-title');
      const searchQuery = (searchInput?.value || '').trim();
      if (resultsHeading) resultsHeading.textContent = searchQuery ? (usedSearchFallback ? 'A few places to start' : `Sessions matching “${searchQuery}”`) : 'Find your next session';
      if (emptyState) emptyState.classList.toggle('is-visible', visibleSessions.length === 0);
      if (loadMore) loadMore.classList.toggle('is-visible', visibleSessions.length > shown);
      if (filterCount) filterCount.textContent = Object.values(applied).flat().length;
      renderActiveFilters();
      const query = (searchInput?.value || '').trim();
      if (searchFeedback) { searchFeedback.hidden = true; searchFeedback.textContent = ''; }
      const selectedNeedItem = needShortcuts.find(item => item.key === selectedNeed);
      if (needFeedback) { needFeedback.hidden = !selectedNeedItem; needFeedback.textContent = selectedNeedItem ? `${selectedNeedItem.label} selected · ${visibleSessions.length} ${visibleSessions.length === 1 ? 'session' : 'sessions'} match. The matching filter is on.` : ''; }
      const selectedCategoryItem = categoryCards.find(item => item.id === selectedCategory);
      if (categoryFeedback) { categoryFeedback.hidden = !selectedCategoryItem; categoryFeedback.textContent = selectedCategoryItem ? `${selectedCategoryItem.title} selected · ${visibleSessions.length} ${visibleSessions.length === 1 ? 'session' : 'sessions'} match. The matching filter is on.` : ''; }
    };
    const render = () => renderResults();
    const renderDialog = () => {
      if (!filterGroups) return;
      const countsByGroup = {};
      const query = (searchInput?.value || '').trim().toLowerCase();
      for (const group of facets) {
        countsByGroup[group.key] = new Map();
        const sourceSessions = selectedCategory === 'mindful' ? guidedMovementSessions : allSessions;
        const matchingOtherFilters = sourceSessions.filter(session => {
          if (!includesCategory(session, selectedCategory)) return false;
          if (query && !searchMatches(session, query)) return false;
          for (const [key, selected] of Object.entries(applied)) {
            if (key === group.key || !selected.length) continue;
            const values = groupValues(session)[key] || [];
            if (key === 'duration') {
              if (!selected.some(value => durationMatches(session, value))) return false;
            } else if (key === 'access') {
              if (!selected.includes(session.access)) return false;
            } else if (!selected.some(value => values.includes(value))) return false;
          }
          return true;
        });
        for (const session of matchingOtherFilters) for (const value of groupValues(session)[group.key] || []) countsByGroup[group.key].set(value,(countsByGroup[group.key].get(value)||0)+1);
      }
      filterGroups.innerHTML = facets.map((group,index) => {
        const optionValues = [...new Set(group.candidates.map(value => ({ 'Overstimulation / too much': 'Overstimulation / overwhelm', 'Low energy / exhaustion': 'Low energy / reset', 'Short on time / quick start': 'Short on time / busy day', 'Self-care / pause for yourself': 'Self-care / pause' }[value] || value)))]; const options = optionValues.filter(value => (countsByGroup[group.key].get(value) || 0) > 0 || (applied[group.key] || []).includes(value));
        return `<details class="st-library-page__filter-group" data-filter-group="${group.key}" ${index === 0 ? 'open' : ''}>
          <summary>${escapeHtml(group.title)}</summary>
          <div class="st-library-page__filter-options">${options.map(value => `<label class="st-library-page__filter-option"><input type="checkbox" value="${escapeHtml(value)}" data-filter-key="${group.key}"><span>${escapeHtml(value)}</span><small class="st-library-page__filter-count">${countsByGroup[group.key].get(value)}</small></label>`).join('')}</div>
        </details>`;
      }).join('');
      syncDialog();
      filterGroups.querySelectorAll('[data-filter-key]').forEach(input => input.addEventListener('change', () => {}));
    };
    const syncDialog = () => {
      if (filterGroups) filterGroups.querySelectorAll('[data-filter-key]').forEach(input => { input.checked = (applied[input.dataset.filterKey] || []).includes(input.value); });
      const match = needShortcuts.find(item => item.values.every(value => (applied.moments || []).includes(value)) && (applied.moments || []).length === item.values.length);
      selectedNeed = match?.key || '';
      if (selectedCategory) { const filter = categoryFilters[selectedCategory]; if (filter && !filter.values.every(value => (applied[filter.key] || []).includes(value))) selectedCategory = ''; }
      needsList?.querySelectorAll('[data-need-query]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.needQuery === selectedNeed)));
      categoryGrid?.querySelectorAll('[data-category]').forEach(item => {
        const filter = categoryFilters[item.dataset.category];
        item.setAttribute('aria-pressed', String(item.dataset.category === selectedCategory && (!filter || filter.values.every(value => (applied[filter.key] || []).includes(value)))));
      });
    };
    const applyDialogFilters = () => {
      const next = {};
      filterGroups?.querySelectorAll('[data-filter-key]:checked').forEach(input => { (next[input.dataset.filterKey] ||= []).push(input.value); });
      applied = next;
      const match = needShortcuts.find(item => item.values.every(value => (applied.moments || []).includes(value)) && (applied.moments || []).length === item.values.length);
      selectedNeed = match?.key || '';
      if (selectedCategory) { const filter = categoryFilters[selectedCategory]; if (filter && !filter.values.every(value => (applied[filter.key] || []).includes(value))) selectedCategory = ''; }
      syncDialog(); shown = perPage; render();
    };
    const resetAllFilters = () => {
      applied = {}; selectedCategory = ''; selectedNeed = '';
      if (searchInput) searchInput.value = '';
      root.querySelectorAll('[data-category], [data-need-query]').forEach(item => item.setAttribute('aria-pressed','false'));
      syncDialog(); shown = perPage; render();
    };

    renderNeedAndCategories();
    (embeddedCatalog ? Promise.resolve().then(() => JSON.parse(embeddedCatalog.textContent)) : fetch(dataUrl, { credentials: 'same-origin' }).then(response => { if (!response.ok) throw new Error(`Catalog request failed: ${response.status}`); return response.json(); }))
      .then(catalog => {
        const catalogSessions = catalog.sessions || [];
        const hasPlayableVideo = session => ['ready', 'duplicate-review'].includes(session.reviewStatus) && session.access !== 'Needs review' && Number(session.durationSeconds) > 0 && !/deleted-video placeholder/i.test(session.description || '');
        allSessions = catalogSessions.filter(session => session.reviewStatus === 'ready' && hasPlayableVideo(session));
        guidedMovementSessions = catalogSessions.filter(session => hasPlayableVideo(session) && belongsToGuidedPlaylist(session));
        if (resultCount) root.dataset.catalogCount = allSessions.length;
        renderFeaturedRow(recentWorkoutRow, /new workouts/i);
        renderFeaturedRow(recentStretchRow, /new stretches/i);
        renderDialog(); render();
      })
      .catch(error => {
        console.error('Sweat Therapy Library could not load its session catalog.', error);
        if (emptyState) { emptyState.classList.add('is-visible'); emptyState.querySelector('h3').textContent = 'Sessions are temporarily unavailable'; emptyState.querySelector('p').textContent = 'Please refresh this page in a moment.'; }
      });

    let semanticTimer = null;
    searchInput?.addEventListener('input', () => {
      shown = perPage;
      const query = searchInput.value.trim();
      if (semanticQueryText !== query) { semanticQueryVector = null; semanticQueryText = ''; }
      render();
      window.clearTimeout(semanticTimer);
      if (query.length < 3 || semanticIndexFailed) return;
      semanticTimer = window.setTimeout(() => requestSemanticQuery(query), 350);
    });
    searchInput?.addEventListener('keydown', event => {
      if (event.key !== 'Enter' || !searchInput.value.trim()) return;
      event.preventDefault(); scrollToResults();
    });
    clearSearch?.addEventListener('click', () => { if (searchInput) { searchInput.value = ''; searchInput.focus(); } shown = perPage; render(); });
    sortControl?.addEventListener('change', render);
    loadMore?.addEventListener('click', () => { shown += perPage; renderResults(); });
    filterButton?.addEventListener('click', () => { renderDialog(); syncDialog(); dialog?.showModal(); });
    root.querySelector('[data-close-filters]')?.addEventListener('click', () => dialog?.close());
    root.querySelector('[data-apply-filters]')?.addEventListener('click', () => { applyDialogFilters(); dialog?.close(); scrollToResults(); });
    root.querySelectorAll('[data-reset-filters]').forEach(button => button.addEventListener('click', resetAllFilters));
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    needsList?.addEventListener('click', event => {
      const button = event.target.closest('[data-need-query]'); if (!button) return;
      const shortcut = needShortcuts.find(item => item.key === button.dataset.needQuery); if (!shortcut) return;
      const selected = selectedNeed === shortcut.key;
      selectedNeed = selected ? '' : shortcut.key;
      selectedCategory = '';
      applied = selected ? {} : { moments: shortcut.values };
      if (searchInput) searchInput.value = '';
      shown = perPage; syncDialog(); render(); scrollToResults();
    });
    categoryGrid?.addEventListener('click', event => {
      const button = event.target.closest('[data-category]'); if (!button) return;
      const selected = selectedCategory === button.dataset.category;
      selectedCategory = selected ? '' : button.dataset.category;
      const filter = categoryFilters[button.dataset.category];
      applied = !selected && filter ? { [filter.key]: filter.values } : {};
      categoryGrid?.querySelectorAll('[data-category]').forEach(item => item.setAttribute('aria-pressed',String(item.dataset.category === selectedCategory)));
      needsList?.querySelectorAll('[data-need-query]').forEach(item => item.setAttribute('aria-pressed','false'));
      selectedNeed = '';
      if (searchInput) searchInput.value = '';
      shown = perPage; syncDialog(); render(); scrollToResults();
    });
  });
})();
